import * as Sentry from "@sentry/react";
import { getSentryDsn, getTelemetryEnvironment, isTelemetryEnabled } from "./env";

export { isTelemetryEnabled };

let initialized = false;

export function initTelemetry(): typeof Sentry | null {
  if (!isTelemetryEnabled()) return null;
  if (initialized) return Sentry;

  const dsn = getSentryDsn();
  if (!dsn) return null;

  Sentry.init({
    dsn,
    environment: getTelemetryEnvironment(),
    // GlitchTip does not support Session Replay.
    integrations: [],
  });

  initialized = true;
  return Sentry;
}
